/* PHESIA - renk kutucuklari.
   1) Urun kartinda renk kutucuguna tiklayinca gorseli ve linki degistirir. (8 Eylul 2026)
   2) Renk kutucuklarinin icini duz renk yerine GERCEK URUN FOTOGRAFI ile doldurur.
      Tedarikci renk isimleri (ornegin "Apricot") gercek kumas rengiyle uyusmuyor;
      fotograf kirpmasi her zaman dogru. (11 Eylul 2026)
      Not: color-swatches.css icinde .swatch[title="..."] kurallari !important ile
      renk basiyor; bu yuzden inline stiller setProperty(...,'important') ile yaziliyor.
      Kirpma kumasa yakinlastirilmis (ZOOM) ki arka plan ve canta degil kumas gorunsun. */
(function () {
  'use strict';

  var SWATCH_W = 200;
  var ZOOM = '260% auto';
  var FOCUS = '50% 40%';

  function small(src) {
    if (!src) return '';
    var u = String(src);
    if (u.indexOf('//') === 0) u = 'https:' + u;
    if (/[?&]width=\d+/.test(u)) return u.replace(/([?&]width=)\d+/, '$1' + SWATCH_W);
    return u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=' + SWATCH_W;
  }

  function paint(el, src) {
    if (!el || !src) return;
    if (el.getAttribute('data-img-painted') === '1') return;
    var url = small(src);
    var img = new Image();
    img.onload = function () {
      el.style.setProperty('background-image', "url('" + url + "')", 'important');
      el.style.setProperty('background-size', ZOOM, 'important');
      el.style.setProperty('background-position', FOCUS, 'important');
      el.style.setProperty('background-repeat', 'no-repeat', 'important');
      el.setAttribute('data-img-painted', '1');
    };
    img.src = url;
  }

  function paintCards(root) {
    var list = (root || document).querySelectorAll('.swatch[data-card-swatch][data-swatch-img]');
    for (var i = 0; i < list.length; i++) {
      paint(list[i], list[i].getAttribute('data-swatch-img'));
    }
  }

  function paintProductPage() {
    var pdp = document.getElementById('pdp');
    var dataEl = document.getElementById('variant-data');
    if (!pdp || !dataEl) return;

    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!variants || !variants.length) return;

    var groups = pdp.querySelectorAll('.swatches[data-option-index]');
    for (var g = 0; g < groups.length; g++) {
      var idx = Number(groups[g].getAttribute('data-option-index'));
      if (isNaN(idx)) continue;
      var sws = groups[g].querySelectorAll('.swatch[data-value]');
      for (var s = 0; s < sws.length; s++) {
        var val = sws[s].getAttribute('data-value');
        var src = '';
        for (var v = 0; v < variants.length; v++) {
          var opts = variants[v].options || [];
          if (opts[idx] === val && variants[v].featured_image && variants[v].featured_image.src) {
            src = variants[v].featured_image.src;
            break;
          }
        }
        if (src) paint(sws[s], src);
      }
    }
  }

  function paintAll() {
    paintCards(document);
    paintProductPage();
  }

  function applySwatch(sw) {
    var card = sw.closest('.product-card');
    if (!card) return;

    var src = sw.getAttribute('data-swatch-img');
    if (src) {
      var main = card.querySelector('.product-media img.main');
      var alt = card.querySelector('.product-media img.alt');
      if (main) {
        main.removeAttribute('srcset');
        main.removeAttribute('sizes');
        main.setAttribute('src', src);
        main.setAttribute('loading', 'eager');
      }
      if (alt) {
        alt.removeAttribute('srcset');
        alt.removeAttribute('sizes');
        alt.setAttribute('src', src);
      }
    }

    var url = sw.getAttribute('data-swatch-url');
    if (url) {
      var media = card.querySelector('a.product-media');
      if (media) media.setAttribute('href', url);
      var titleLink = card.querySelector('.product-info h3 a');
      if (titleLink) titleLink.setAttribute('href', url);
    }

    var group = sw.parentNode;
    if (group) {
      var all = group.querySelectorAll('.swatch');
      for (var i = 0; i < all.length; i++) all[i].classList.remove('active');
    }
    sw.classList.add('active');
  }

  function findSwatch(target) {
    if (!target || !target.closest) return null;
    return target.closest('.swatch[data-card-swatch]');
  }

  document.addEventListener('click', function (e) {
    var sw = findSwatch(e.target);
    if (!sw) return;
    e.preventDefault();
    e.stopPropagation();
    applySwatch(sw);
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    var sw = findSwatch(e.target);
    if (!sw) return;
    e.preventDefault();
    e.stopPropagation();
    applySwatch(sw);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', paintAll);
  } else {
    paintAll();
  }
  setTimeout(paintAll, 600);
  setTimeout(paintAll, 2000);

  if (window.MutationObserver) {
    var pending = null;
    var mo = new MutationObserver(function () {
      if (pending) return;
      pending = setTimeout(function () { pending = null; paintCards(document); }, 200);
    });
    if (document.body) mo.observe(document.body, { childList: true, subtree: true });
  }
})();